export default __webpack_public_path__ + "static/media/info_start.min.1fa2ba80.png";